import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {Scrollbar} from 'react-scrollbars-custom'
import {useSelector} from 'react-redux'
import actions from 'redux-auto'
import ChatMessage from '#components/a/Chat/ChatMessage'
import OwnChatMessage from '#components/a/Chat/OwnChatMessage'
import Text from '#components/a/Text'
import ChatInfoItem from '#components/a/Chat/ChatInfoItem'

function ChatMessagesList({chatId}) {
  const scrollbar = useRef(null)
  const messages = useSelector(state => state.chat.activities[chatId])
  const hasNewActivities = useSelector(state => state.chat.chats[chatId].hasNewActivities)

  const markChatAsReadDelay = 1000

  useEffect(() => {
    if (scrollbar && scrollbar.current) {
      scrollbar.current.scrollToBottom()
    }
    if (hasNewActivities) {
      const timer = setTimeout(() => {
        actions.chat.markChatAsRead({chatId})
      }, markChatAsReadDelay)
      return () => {
        clearTimeout(timer)
      }
    }

    return () => {}
  })

  return (
    <>
      <div className="chat-message-list">
        <Scrollbar className="scrollBarWrapper" ref={scrollbar} noScrollX={true}>
          <ChatInfoItem messageText={i18n.t('chats_disclaimer_message_expiry')} />
          {messages && (
            <div className="chat-messages">
              {messages.map(message =>
                message.isOwnMessage ? (
                  <OwnChatMessage key={message.id} messageText={message.messageText} timestamp={message.timestamp} />
                ) : (
                  <ChatMessage
                    key={message.id}
                    userName={message.userName}
                    messageText={message.messageText}
                    timestamp={message.timestamp}
                  />
                ),
              )}
              {messages.length === 0 && (
                <Text
                  modifier="no-messages"
                  text={i18n.t('chat_messages_no_messages')}
                  data-testid="no-chat-messages"
                />
              )}
            </div>
          )}
        </Scrollbar>
      </div>
    </>
  )
}

ChatMessagesList.propTypes = {
  chatId: PropTypes.string.isRequired,
}

export default ChatMessagesList
